export default __webpack_public_path__ + "static/media/FridayRingRing.4074b6ae.png";